/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Create an adapter that converts an object of props with potentially deprecated
 * prop names to the replacement prop names in a newer version. Useful for guarding
 * against breaking changes when a prop has been renamed
 *
 * @param {Array} spec - an array of options which specify a text or regex
 * matcher alongside a replacement if there is a match
 * @returns {Function}
 */
function mapPopoverAlignProp(align) {
  switch (align) {
    case 'top-left':
      return 'top-start';
    case 'top-right':
      return 'top-end';
    case 'bottom-left':
      return 'bottom-start';
    case 'bottom-right':
      return 'bottom-end';
    case 'left-bottom':
      return 'left-end';
    case 'left-top':
      return 'left-start';
    case 'right-bottom':
      return 'right-end';
    case 'right-top':
      return 'right-start';
    default:
      return align;
  }
}

exports.mapPopoverAlignProp = mapPopoverAlignProp;
